import PropTypes from 'prop-types';
import React from 'react';

function DoubleClickDiv(props) {
  const {delay, children, customRef, className, onClick, onDoubleClick} = props;
  let timeout = null;

  const onClickHandler = (e) => {
    e.preventDefault();

    if (timeout === null) {
      timeout = setTimeout(() => {
        clearTimeout(timeout);
        timeout = null;

        onClick();
      }, delay);
    }
  };

  const onDoubleClickHandler = (e) => {
    e.preventDefault();
    clearTimeout(timeout);
    timeout = null;

    onDoubleClick();
  };

  return (
    <div
      ref={customRef}
      className={className}
      onClick={onClickHandler}
      onDoubleClick={onDoubleClickHandler}
      // {...props}
    >
      {children}
    </div>
  );
}

DoubleClickDiv.propTypes = {
  delay: PropTypes.number,
  children: PropTypes.any.isRequired,
  customRef: PropTypes.any,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
};

DoubleClickDiv.defaultProps = {
  delay: 100,
  customRef: null,
  className: '',
  onClick: () => {},
  onDoubleClick: () => {},
};

export default DoubleClickDiv;
